import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { userSelector } from '../User/selectors';
import { HiddenChat } from '../../Components/HiddenChat/HiddenChat.tsx';

function Component(props) {
  const userId = props.user?.id?.toString();

  if (!userId) return <div>Missing user id.</div>;

  return <HiddenChat userId={userId} />;
}

const mapStateToProps = (state) => ({
  user: userSelector(state),
});

const mapDispatchToProps = () => ({});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Component),
);
